import { render, staticRenderFns } from "./stopUsingPopup.vue?vue&type=template&id=6a72dec5&scoped=true"
import script from "./stopUsingPopup.vue?vue&type=script&lang=js"
export * from "./stopUsingPopup.vue?vue&type=script&lang=js"
import style0 from "./stopUsingPopup.vue?vue&type=style&index=0&id=6a72dec5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a72dec5",
  null
  
)

export default component.exports